import { createContext, useState, type Dispatch, type SetStateAction, type ReactNode } from 'react';

export interface ProjectMinMaxValidationState {
  internalSpace: boolean;
  terraceSpace: boolean;
  numberOfTerrace: boolean;
  yearlyHeatingPeakMonth: boolean;
  yearlyCoolingPeakMonth: boolean;
  photovoltaicSurfaceForSite: boolean;
  thermalCollectorsSurface: boolean;
  sizeOfTheArea: boolean;
  photovoltaicSurfaceForLand: boolean;
}

export interface GridMinMaxValidationState {
  terrainResolutionClose: boolean;
  gridResolution: boolean;
  gridAngle: boolean;
  gridHeight: boolean;
  customGridElevation: boolean;
  sensorPointsHeightFromGround: boolean;
  flatTerrainHeight: boolean;
}

export interface ValidationMinMaxContextValue {
  isValidProjectMinMaxInputs: ProjectMinMaxValidationState;
  setIsValidProjectMinMaxInputs: Dispatch<SetStateAction<ProjectMinMaxValidationState>>;
  clearValidationProjectMinMaxInputs: () => void;
  isValidGridMinMaxInputs: GridMinMaxValidationState;
  setIsValidGridMinMaxInputs: Dispatch<SetStateAction<GridMinMaxValidationState>>;
  clearValidationGridMinMaxInputs: () => void;
}

export const ValidationMinMaxContext = createContext<ValidationMinMaxContextValue>({} as ValidationMinMaxContextValue);

interface ValidationMinMaxContextProviderProps {
  children: ReactNode;
}

const ValidationMinMaxContextProvider = (props: ValidationMinMaxContextProviderProps) => {
  const initialStateForProject = {
    internalSpace: true,
    terraceSpace: true,
    numberOfTerrace: true,
    yearlyHeatingPeakMonth: true,
    yearlyCoolingPeakMonth: true,
    photovoltaicSurfaceForSite: true,
    thermalCollectorsSurface: true,
    sizeOfTheArea: true,
    photovoltaicSurfaceForLand: true,
  };

  const initialStateForGrid = {
    terrainResolutionClose: true,
    gridResolution: true,
    gridAngle: true,
    gridHeight: true,
    customGridElevation: true,
    sensorPointsHeightFromGround: true,
    flatTerrainHeight: true,
  };

  const [isValidProjectMinMaxInputs, setIsValidProjectMinMaxInputs] = useState(initialStateForProject);

  const [isValidGridMinMaxInputs, setIsValidGridMinMaxInputs] = useState(initialStateForGrid);

  const clearValidationProjectMinMaxInputs = () => {
    setIsValidProjectMinMaxInputs(initialStateForProject);
  };

  const clearValidationGridMinMaxInputs = () => {
    setIsValidGridMinMaxInputs(initialStateForGrid);
  };

  return (
    <ValidationMinMaxContext.Provider
      value={{
        isValidProjectMinMaxInputs,
        setIsValidProjectMinMaxInputs,
        clearValidationProjectMinMaxInputs,

        isValidGridMinMaxInputs,
        setIsValidGridMinMaxInputs,
        clearValidationGridMinMaxInputs,
      }}
    >
      {props.children}
    </ValidationMinMaxContext.Provider>
  );
};

export default ValidationMinMaxContextProvider;
